export default __webpack_public_path__ + "static/media/Search.06b75f61.svg";